import { useAuth } from './useAuth';
import { useSettingsMarketplace } from './useSettingsMarketplace';

export const useSettingsTimeZone = (): string => {
    const auth = useAuth();
    const marketplace = useSettingsMarketplace();

    return marketplace?.schedule?.timeZone || auth.timeZone!;
};

export default useSettingsTimeZone;
